// maestroo docs on javascript events exposed by the theme
// https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme


var sidebar_country_dropdown = document.querySelector('#sidebar-menu .county_wrapper .flag-icon');
if(sidebar_country_dropdown) {
    sidebar_country_dropdown.addEventListener("click", function(e) {
      console.log('click');
      var parent = this.closest('.county_wrapper');
      var sidebarElem = this.closest('#sidebar-menu');
      sidebarElem.classList.add('open_contry_select');
      parent.classList.add('active');
    });

    var countries_links_close = document.querySelector('#sidebar-menu .county_wrapper .countries-links_close');
    countries_links_close.addEventListener("click", function(e) {
      var parent = this.closest('.county_wrapper');
      var sidebarElem = this.closest('#sidebar-menu');
      sidebarElem.classList.remove('open_contry_select');
      parent.classList.remove('active');
    });
  }


  //update cart count
  // document.querySelector('.cart-count').textContent = '5'; 

// added to cart
  // document.addEventListener('variant:add', function(event) {
  //   let items = event.detail.items; // Get items added
  //   let cart = event.detail.cart; // The whole cart content after the update
  //   console.log('Item added to cart');
  // });

  // cart line item has changed
  // document.addEventListener('line-item:change', function(event) {
  //   let finalQuantity = event.detail.quantity; // New quantity (may be 0 !)
  //   let cart = event.detail.cart;
  //   console.log('Cart line item has changed');
  // });

// adjust z-index of smile.io popup
  const observer = new MutationObserver(() => {
    const container = document.querySelector('#smile-ui-container, #smile-ui-lite-container');
    if (container) {
      container.style.setProperty('z-index', '5', 'important');
      observer.disconnect(); // stop observing once it's applied
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
// cartixß
// this will add item to cartix cart
//  window.CD_ADDTOCART({
//     id: '39654215221303',
//     quantity: 1
//   }); 

// checks if the cartdrawer script is loaded - useful to wrap logic 
  // window.CD_LOADED() 

// refresh the cart contents and open the cart
// window.CD_REFRESHCART().then(() => window.CD_OPENCART());

class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('.custom-dropdown__details');
    this.summary = this.querySelector('.custom-dropdown__summary');
    this.selectedText = this.querySelector('.custom-dropdown__selected-text');
    this.buttons = this.querySelectorAll('.custom-dropdown__button');
    
    const carouselId = this.summary.getAttribute('aria-controls');
    this.carousel = document.getElementById(carouselId);

    this.bindEvents();
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.onOptionClick(event, button));
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target) && this.details.hasAttribute('open')) {
        this.details.removeAttribute('open');
      }
    });
  }

  onOptionClick(event, button) {
    event.preventDefault();

    const newTitle = button.getAttribute('data-title');
    if (this.selectedText && newTitle) {
      this.selectedText.textContent = newTitle;
    }

    this.details.removeAttribute('open');

    const currentLi = button.closest('li');
    this.querySelectorAll('li').forEach(li => li.setAttribute('aria-selected', 'false'));
    currentLi.setAttribute('aria-selected', 'true');

    const index = parseInt(currentLi.getAttribute('data-index'), 10);
    
    if (this.carousel) {
      const carouselItems = this.carousel.querySelectorAll('.featured-collections-carousel__item');
      
      if (carouselItems.length > 0) {
        carouselItems.forEach((item, i) => {
          if (i === index) {
            item.classList.add('is-selected');
            item.removeAttribute('hidden'); 
          } else {
            item.classList.remove('is-selected');
            item.setAttribute('hidden', '');
          }
        });
      }

      // If the theme's carousel has a native select method, trigger it
      if (typeof this.carousel.select === 'function') {
        this.carousel.select(index);
      }
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);

(function initGlowAdvisor() {
  const HOST_SELECTOR = '#skin-advisor-root';
  const BUTTON_SELECTOR = 'button[aria-label="Open Glow Advisor"]';
  const TRIGGER_SELECTOR = '.glow-adviser-trigger';
  const STYLE_ID = 'hide-glow-style';

  // Forward clicks from custom triggers to the Shadow DOM button.
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    event.preventDefault();

    const shadowHost = document.querySelector(HOST_SELECTOR);
    const targetButton = shadowHost?.shadowRoot?.querySelector(BUTTON_SELECTOR);

    targetButton?.click();
  });

  // Hide the default floating button.
  function hideIconInstantly() {
    const shadowHost = document.querySelector(HOST_SELECTOR);
    const shadowRoot = shadowHost?.shadowRoot;

    if (!shadowRoot) return false;

    // Avoid injecting duplicate styles.
    if (shadowRoot.getElementById(STYLE_ID)) return true;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      ${BUTTON_SELECTOR} {
        display: none !important;
      }
    `;

    shadowRoot.appendChild(style);
    return true;
  }

  // Try immediately.
  if (hideIconInstantly()) return;

  // Watch for asynchronously created Shadow DOM.
  const observer = new MutationObserver(() => {
    if (hideIconInstantly()) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();